module.exports = __webpack_public_path__ + "9ac6e3d2a7fb76468bd417ea40b6f8c4.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/Inconsolata/Inconsolata-Regular.ttf
// module id = 345
// module chunks = 0